/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../base.component';
import { Component } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss']
})

export class LogoComponent extends BaseComponent {
    /**
     * Link location when clicking on the logo.
     */
    public routerLink: string;

    /**
     * Store image source.
     */
    public imageSource: string;

    /**
     * Store the product name.
     */
    public productName: string;

    constructor() {
        super();
        this.routerLink = this.getRouterLink();
        this.imageSource = this.getLogoSource();
        this.productName = this.getProductName();
    }

    /**
     * Sets router link
     * @private
     */
    private getRouterLink(): string {
        if (this.environment.module === this.modulesEnum.LOADBALANCER) {
            const lbUser = localStorage.getItem('lbUser');
            const userObject = JSON.parse(lbUser);
            const applianceId = userObject && userObject.applianceId;

            return `/lb/${applianceId}/overview`;
        } else {
            return '/cm/dashboard';
        }
    }

    /**
     * Get logo source.
     * @private
     */
    private getLogoSource(): string {
        return '../../../assets/shared/logos/logo-with-text';
    }

    /**
     * Get product name.
     * @private
     */
    private getProductName(): string {
        return this.environment.module === this.modulesEnum.LOADBALANCER
            ? 'endurance'
            : 'PORTAL';
    }
}
